import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';
import LandingZonesEmbed from '../components/LandingZonesEmbed/LandingZonesEmbed';
import styles from './Main.module.css';

const Main: React.FC = () => {
  return (
    <div className={styles.page}>
      <Box>
        <Text size="header" fontWeight="bold" color="primaryText">
          Landing Zones
        </Text>
      </Box>
      <Box mt={8} mb={20}>
        <Text size="normal" color="secondaryText">
          Add, edit, and review the air ambulance landing zones for your ECC.
        </Text>
      </Box>
      <LandingZonesEmbed />
    </div>
  );
};

export default Main;
